import { BetStateBitMask, updateBetStateBitMask } from '../../../logger/BetStateBitMask';
import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { autoplayActions } from '../../../store/slices/autoplay/slice';
import { toastActions } from '../../../store/slices/toast/slice';
import { countTotalBet, getMinimalBet } from '../../../utils/bets';

export class GameCommunicationLowBalanceAwareProcessor {
  checkLowBalanceAndUpdateState(store: CoreStoreType): boolean {
    const state = store.getState();
    const balance = state.gameState.userInfo?.balance;
    const betLimits = state.bets.betLimits;

    const minBetSize = getMinimalBet(betLimits);
    const isLowBalance = !balance || (balance.amount < minBetSize && balance.bonus < minBetSize);
    if (isLowBalance) {
      updateBetStateBitMask(BetStateBitMask.InsufficientFunds);
    }
    return isLowBalance;
  }

  checkAutoplayAvailability(store: CoreStoreType): void {
    const state = store.getState();
    const balance = state.gameState.userInfo?.balance;
    const { isInProgress, savedBet } = state.autoplay;

    if (isInProgress) {
      const totalBet = countTotalBet(savedBet?.betSpots ?? {}, state.gameState.currencyInfo?.digitsNumber ?? 0);

      const savedBetSpots = Object.keys(savedBet?.betSpots ?? {}).filter(
        (el) => (savedBet?.betSpots?.[el]?.value ?? 0) > 0
      );
      const allBetsUnavailable = savedBetSpots.every((r) => state.bets.disabledBetSpots.includes(r));

      if (allBetsUnavailable) {
        store.dispatch(autoplayActions.stop());
        store.dispatch(toastActions.createToast('AUTOPLAY_PREFERENCES_STOPPED'));
        Logger.logEvent('click', 'autoplay_stop', Date.now(), 1, 'BetsUnavailable', false);
      }

      const currBalance = balance ? balance.amount + balance.bonus : 0;
      if (totalBet > currBalance) {
        store.dispatch(autoplayActions.stop());
        store.dispatch(toastActions.createToast('AUTOPLAY_SUPPORT_CURR_BAL'));
        Logger.logEvent('click', 'autoplay_stop', Date.now(), 1, 'NoMoney', false);
      }
    }
  }
}
